import { render, staticRenderFns } from "./faraway.vue?vue&type=template&id=b36bd078&scoped=true"
import script from "./faraway.vue?vue&type=script&lang=js"
export * from "./faraway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36bd078",
  null
  
)

export default component.exports